var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGreen = function SvgGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 584 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__a)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.535.462H.511v65.075h65.024V.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.517 0c0 18.19-14.538 32.94-32.513 32.94C15.03 32.94.566 18.228.566 0M65.87 32.977H0M13.414 54.517c2.847 0 5.155-2.299 5.155-5.135s-2.308-5.135-5.155-5.135c-2.848 0-5.156 2.299-5.156 5.135s2.309 5.135 5.156 5.135ZM32.94 54.517c2.847 0 5.155-2.299 5.155-5.135s-2.308-5.135-5.155-5.135c-2.848 0-5.156 2.299-5.156 5.135s2.308 5.135 5.156 5.135ZM52.456 54.517c2.848 0 5.156-2.299 5.156-5.135s-2.308-5.135-5.156-5.135c-2.847 0-5.155 2.299-5.155 5.135s2.308 5.135 5.155 5.135Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__b)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.464.518v65.02h65.063V.518H65.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.464 33.023c4.278.005 8.513.85 12.463 2.487a32.574 32.574 0 0 1 10.559 7.053 32.461 32.461 0 0 1 7.047 10.544 32.383 32.383 0 0 1 2.463 12.431M98.005.518a32.38 32.38 0 0 1-2.466 12.43 32.46 32.46 0 0 1-7.05 10.543 32.576 32.576 0 0 1-10.562 7.05 32.658 32.658 0 0 1-12.463 2.482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.481 65.538V.462H65.464v65.076h65.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.481 32.995a32.662 32.662 0 0 1-12.459-2.496 32.586 32.586 0 0 1-10.552-7.059 32.468 32.468 0 0 1-7.039-10.548A32.389 32.389 0 0 1 97.977.463M97.968 65.538a32.388 32.388 0 0 1 2.455-12.434 32.469 32.469 0 0 1 7.041-10.55 32.587 32.587 0 0 1 10.555-7.061 32.665 32.665 0 0 1 12.462-2.497"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__c)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.542.462h-64.084v65.075h64.084V.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.542 30.813c0 19.009-14.345 34.42-32.06 34.42-17.716 0-32.024-15.411-32.024-34.42M194.459 33.014h-63.946M130.403.324l32.124 32.486M194.633.324 162.518 32.8M166.02 19.738c1.87-2.08 1.716-5.298-.344-7.186a5.004 5.004 0 0 0-7.117.347 5.123 5.123 0 0 0 .345 7.187 5.003 5.003 0 0 0 7.116-.348Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__d)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.47 32.986h-15.62M275.207 32.986h-15.394M274.063 35.314a20.484 20.484 0 0 0-.295 19.049 20.376 20.376 0 0 0 6.391 7.42 20.231 20.231 0 0 0 9.099 3.561c.696.099 1.396.16 2.099.18h-31.884V.476h32.621l-16.821 32.501-1.21 2.338ZM324.527.475v65.04h-31.771a18.462 18.462 0 0 0 2.071-.17 20.255 20.255 0 0 0 9.167-3.645 20.403 20.403 0 0 0 6.383-7.551 20.502 20.502 0 0 0 2.094-9.682 20.502 20.502 0 0 0-2.685-9.533l-.048-.105-.945-1.853-16.699-32.5h32.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.305 65.278h-3.102v.484h3.102v-.484Z",
    fill: "#00412F",
    strokeWidth: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__e)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.735 22.339c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648 2.688 0 2.678 5.648 5.356 5.648s2.687-5.648 5.374-5.648 2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.374 5.648s2.678-5.648 5.365-5.648c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648M324.735 13.368c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648 2.688 0 2.678 5.648 5.356 5.648s2.687-5.648 5.374-5.648 2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.374 5.648s2.678-5.648 5.365-5.648c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648M324.735 5.328c2.678 0 2.678 5.648 5.365 5.648 2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.365-5.648 2.677 0 2.687 5.648 5.365 5.648 2.677 0 2.687-5.648 5.374-5.648s2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.374-5.648s2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.528.47h-65.057v65.06h65.057V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.519 33.042c0 17.491-14.548 31.668-32.5 31.668-17.952 0-32.491-14.177-32.491-31.667M324.631 33.005h64.69"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__f)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.536.471h-64.072v65.057h64.072V.471Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.331 33a32.629 32.629 0 0 1-2.477 12.321 32.25 32.25 0 0 1-6.934 10.42 31.7 31.7 0 0 1-10.334 6.93 31.311 31.311 0 0 1-12.16 2.386 31.304 31.304 0 0 1-12.16-2.385 31.693 31.693 0 0 1-10.335-6.931 32.25 32.25 0 0 1-6.934-10.42A32.667 32.667 0 0 1 389.52 33M389.52 32.962h63.811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.529 33c.02-4.233.86-8.42 2.474-12.321a32.23 32.23 0 0 1 6.932-10.42 31.682 31.682 0 0 1 10.332-6.93A31.301 31.301 0 0 1 421.426.941c4.168-.023 8.3.787 12.16 2.386a31.7 31.7 0 0 1 10.334 6.93 32.25 32.25 0 0 1 6.934 10.42A32.63 32.63 0 0 1 453.331 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.11 33c0-7.087 2.772-13.883 7.708-18.894 4.935-5.012 11.628-7.827 18.608-7.827 6.979 0 13.672 2.815 18.608 7.827 4.935 5.01 7.707 11.807 7.707 18.894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.7 33c0-5.582 2.184-10.934 6.071-14.881 3.886-3.947 9.158-6.164 14.655-6.164s10.768 2.217 14.655 6.164c3.887 3.947 6.071 9.3 6.071 14.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.29 33a15.49 15.49 0 0 1 4.565-10.627 15.025 15.025 0 0 1 10.575-4.37c3.952 0 7.747 1.568 10.576 4.37A15.49 15.49 0 0 1 436.571 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.88 33a9.768 9.768 0 0 1 2.9-6.664 9.48 9.48 0 0 1 6.65-2.736c2.483 0 4.868.981 6.651 2.736a9.777 9.777 0 0 1 2.9 6.664"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__g)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.528.472h-65.057v65.057h65.057V.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.528.443a32.53 32.53 0 1 1-65.057 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.49 32.925a32.491 32.491 0 1 1-64.981 0M518.689 33h-65.161"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__h)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.471.478v65.025h65.058V.478h-65.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.179.675c19.339 0 35.003 14.512 35.003 32.428 0 17.916-15.664 32.428-35.003 32.428M194.782 32.981h34.767M230.105 65.09V.948M236.335.947V65.09M242.555.947V65.08M248.785.947V65.08M255.005.947V65.08"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green_svg__i)",
    stroke: "#00412F",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.528.471h-65.056v65.057h65.056V.471Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.576 33.085a32.376 32.376 0 0 1 9.5-22.908A32.451 32.451 0 0 1 551.01.688a32.453 32.453 0 0 1 22.934 9.489 32.38 32.38 0 0 1 9.499 22.908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.443 33a32.406 32.406 0 0 1-9.699 22.57 32.483 32.483 0 0 1-22.758 9.302 32.48 32.48 0 0 1-22.757-9.302 32.403 32.403 0 0 1-9.7-22.57M518.576 33h64.764"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(65)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(130)",
    d: "M0 0h65v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(259)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(324)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(389)",
    d: "M0 0h65v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(453)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(194)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "green_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(518)",
    d: "M0 0h66v66H0z"
  })))));
};

export { SvgGreen as ReactComponent };
export default __webpack_public_path__ + "static/green.78dd1090.svg";